module.exports = __webpack_public_path__ + "static/media/FFEP_230724.1f7f0836.jpg";